.suggestions-chips {
  display: flex;
  align-items: center;
  gap: var(--spacing-m, $spacing-m);
  padding: var(--radius-s, $spacing-s) var(--radius-l, $spacing-l);
  list-style: none;
  margin: 0;
  overflow-x: auto;

  // TODO: check scroll styles
  // Maybe move somewhere else to reuse in some somponents, but not globally
  &::-webkit-scrollbar {
    height: 0em;
    background-color: transparent;
  }

  @media (--sm-min) {
    justify-content: center;
    flex-wrap: wrap;
  }
}

.suggestion-button-chips {
  @include span();
  cursor: pointer;
  border-radius: var(--radius-l, $radius-l);
  border: 1px solid var(--border-color-primary, border-color('primary'));
  padding: var(--spacing-s, $spacing-s);
  display: flex;
  align-items: center;
  column-gap: var(--spacing-s, $spacing-s);
  background-color: var(--background-color-secondary, background-color('secondary'));
  width: max-content;
  color: var(--text-color-secondary, text-color('secondary'));
  transition: background-color 0.2s;

  @media (hover: hover) {
    &:hover {
      background-color: var(--background-color-tertiary, background-color('tertiary'));
    }
  }

  &:focus-visible {
    outline: none;
    border: 1px solid var(--border-color-accent, border-color('accent'));
  }
}

.suggestions-list {
  display: flex;
  align-items: center;
  padding: 0;
  list-style: none;
  margin: 0;
  flex-wrap: wrap;
}

.suggestion-item-list {
  width: 100%;
}

.suggestion-button-list {
  display: flex;
  align-items: center;
  text-align: left;
  column-gap: var(--spacing-s, $spacing-s);
  border: 0;
  background-color: transparent;
  font-size: var(--font-size-sm, $font-size-sm);
  cursor: pointer;
  padding: var(--spacing-s, $spacing-s) var(--spacing-m, $spacing-m);
  color: var(--text-color-secondary, text-color('secondary'));
  background: linear-gradient(90deg, var(--text-color-accent, text-color('accent')) 0%, var(--text-color-primary, text-color()) 100%);
  background-clip: text;
  -webkit-text-fill-color: transparent;
  width: 100%;
  border: 1px solid transparent;
  font-family: inherit;

  &:focus-visible {
    outline: none;
    border: 1px solid var(--border-color-accent, border-color('accent'));
    border-radius: var(--radius-s, $radius-s);
  }
}
